import { idbReq, idbTxDone, openOfflineDb } from './idb';

export async function kvSet(platform: string, key: string, value: unknown): Promise<void> {
  const db = await openOfflineDb(platform);
  const tx = db.transaction('kv', 'readwrite');
  tx.objectStore('kv').put({ key, value, updatedAt: Date.now() });
  await idbTxDone(tx);
  db.close();
}

export async function kvGet<T = unknown>(platform: string, key: string): Promise<T | undefined> {
  const db = await openOfflineDb(platform);
  const tx = db.transaction('kv', 'readonly');
  const row = (await idbReq(tx.objectStore('kv').get(key))) as { value?: T } | undefined;
  db.close();
  return row?.value;
}

export async function kvRemove(platform: string, key: string): Promise<void> {
  const db = await openOfflineDb(platform);
  const tx = db.transaction('kv', 'readwrite');
  tx.objectStore('kv').delete(key);
  await idbTxDone(tx);
  db.close();
}
